<template>
  <div class="weather-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '4')" title="全局配置" name="4">
          <div
              class="setting-item clearFloat"
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
          >
            <div class="content">
              <div class="verticallyCenter">
                <el-checkbox v-model="showSelectCity">显示固定城市天气</el-checkbox>
                <el-tooltip
                    popper-class="width200"
                    effect="dark"
                    content="不勾选则根据ip动态展示天气信息"
                    placement="top"
                    :open-delay="1000"
                >
                  <span class="tips-btn icon-portal-info2"></span>
                </el-tooltip>
              </div>
              <div class="mt16" v-if="showSelectCity">
                <cx-select
                    v-if="provinceData.length"
                    @change="changeProvince"
                    :value="province"
                    :selectOptions="provinceData"
                    title="省"
                    titleSize="13%"
                />
                <cx-select
                    class="mt16"
                    v-if="province.length && province !== '全国' && !isSpecialProvince"
                    @change="changeCity"
                    :value="city"
                    :selectOptions="cityData"
                    title="市"
                    titleSize="13%"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '2')" title="样式" name="2">
          <div
            class="setting-item clearFloat mb16"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <div class="content">
              <div class="mb16">
                <el-checkbox v-model="showCity">显示城市</el-checkbox>
              </div>
              <div class="mb16">
                <el-checkbox v-model="showDayTemp">显示当前温度</el-checkbox>
              </div>
              <div class="mb16">
                <el-checkbox v-model="showTempRange">显示最高最低温度</el-checkbox>
              </div>
              <div class="mb16">
                <el-checkbox v-model="showIcon">显示天气图标</el-checkbox>
              </div>
              <div class="mb16">
                <el-checkbox v-model="showWeatherText">显示天气说明</el-checkbox>
              </div>
              <div class="verticallyCenter mb16">
                <span class="font14 mr16">图标样式</span>
                <el-select popper-class="date-style-select" class="flex1" v-model="iconStyle" placeholder="请选择">
                  <el-option v-for="item in iconStyles" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <p class="font14 mb8">间距</p>
              <slider-and-input
                class="mb16"
                inputWidth="large"
                inputHeight="small"
                :value.sync="spacing"
                title=""
                titlePosition="singleLine"
                :sliderMax="iconMaxSize"
                suffix="px"
              />
              <p class="font14 mb8">图标大小</p>
              <slider-and-input
                class="mb16"
                inputWidth="large"
                inputHeight="small"
                :value.sync="iconSize"
                title=""
                titlePosition="singleLine"
                :sliderMax="iconMaxSize"
                suffix="px"
              />
              <div class="mt16 mb8">文字样式</div>
              <text-setting-update
                :fontColor.sync="color"
                :fontFamily.sync="fontFamily"
                :fontSize.sync="fontSize"
                :fontWeight.sync="fontWeight"
              />
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"

export default {
  name: "weather-options-data",
  components: {
    controlWidthAndSizeAndZindex,
    bigScreenAnimateSet: () => import("components/stageComponents/toolbar/bigScreen-animate-set.vue")
  },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
      hoverOpt: [],
      this1: this,
      collapseActiveNames: ["1", "2", "3", "4"],
      activeType: 1,
      sliderMax: 360,
      iconMaxSize: 100,
      // fontFamilyList: [
      //   {
      //     value: "默认",
      //     label: "default"
      //   },
      //   {
      //     value: "默认字体",
      //     label: "PingFang SC"
      //   }
      // ],
      bgTypes: [
        {
          name: "主题色"
        },
        {
          name: "自定义"
        }
      ],
      iconStyles: [
        {
          value: 1,
          label: "多色"
        },
        {
          value: 2,
          label: "纯色"
        }
      ],
      provinceData: [],
      cityData: [],
      pcaCode: null,
      specialProvinceList: ["北京市", "天津市", "上海市", "重庆市"],
      isSpecialProvince: false
    }
  },
  comments: {},
  created() {
    if (localStorage.getItem("pca-code")) {
      this.pcaCode = JSON.parse(localStorage.getItem("pca-code"))
      this.initProvinceData()
    } else {
      this.instance.get("sv2/assets/map/pca-code.json").then(res => {
        const data = res.data
        this.pcaCode = data
        window.localStorage.setItem("pca-code", JSON.stringify(data))
        this.initProvinceData()
      })
    }
  },

  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    bgType: {
      get() {
        return this.options.bgType || "主题色"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgType", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    colorType: {
      get() {
        return this.options.colorType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "colorType", false)
      }
    },
    startColor: {
      get() {
        return this.options.startColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "startColor", false)
      }
    },
    endColor: {
      get() {
        return this.options.endColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "endColor", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor || "#fff"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    showCity: {
      get() {
        return this.options.showCity
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showCity", false)
      }
    },
    showIcon: {
      get() {
        return this.options.showIcon
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showIcon", false)
      }
    },
    showDayTemp: {
      get() {
        return this.options.showDayTemp
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showDayTemp", false)
      }
    },
    showTempRange:{
      get() {
        return this.options.showTempRange || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showTempRange", false)
      }
    },
    showWeatherText: {
      get() {
        return this.options.showWeatherText
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showWeatherText", false)
      }
    },
    spacing: {
      get() {
        return this.options.spacing
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "spacing", false)
      }
    },
    iconSize: {
      get() {
        return Number(this.options.iconSize) || 20
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSize", false)
      }
    },
    iconStyle: {
      get() {
        return this.options.iconStyle || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconStyle", false)
      }
    },
    showSelectCity:{
      get() {
        return this.options.showSelectCity || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showSelectCity", false)
      }
    },
    province() {
      const nameList = this.options.selectName?.split("/") || []
      const province = nameList.length > 1 ? nameList[0].split(".")[0] : "全国"
      this.initCitysData(this.options.selectName)
      if(this.specialProvinceList.indexOf(province) !== -1){
        this.isSpecialProvince = true
      }else{
        this.isSpecialProvince = false
      }
      return province
    },
    city() {
      const nameList = this.options.selectName?.split("/")
      if (nameList.length > 1) {
        const cityName = nameList[1].split(".")[0]
        if (cityName === this.province) {
          return ""
        } else return cityName
      } else return ""
    },

  },
  methods: {
    switchHandle(type) {
      this.activeType = type
    },
    changeStyle(flag, temp, hoverFlag) {
      let curFontStyleList = hoverFlag ? "hoverFontStyleList" : "fontStyleList"
      switch (flag) {
        case 0:
          let fontWeightName = hoverFlag ? hoverFlag + "FontWeight" : "fontWeight"
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this[fontWeightName] = 400
          } else {
            this[curFontStyleList][flag].isActive = true
            this[fontWeightName] = 500
          }
          break
        case 1:
          let fontStyleName = hoverFlag ? hoverFlag + "FontStyle" : "fontStyle"
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this[fontStyleName] = "normal"
          } else {
            this[curFontStyleList][flag].isActive = true
            this[fontStyleName] = "italic"
          }
          break
        case 2:
          let textDecorationName = hoverFlag ? hoverFlag + "TextDecoration" : "textDecoration"
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this[textDecorationName] = "none"
          } else {
            this[curFontStyleList][flag].isActive = true
            this[textDecorationName] = "underline"
          }
          break
      }
    },
    changeArrangement(val, hoverFlag) {
      let cutTextAlign = hoverFlag ? hoverFlag + "TextAlign" : "textAlign"
      this[cutTextAlign] = val.value
    },
    changeArrangementOrder(flag, hoverFlag) {
      let curActiveArrangementOrder = hoverFlag ? hoverFlag + "ActiveArrangementOrder" : "activeArrangementOrder"
      let curWritingMode = hoverFlag ? hoverFlag + "WritingMode" : "writingMode"

      if (flag) {
        this[curActiveArrangementOrder].isActive = false
        // this[curWritingMode] = "horizontal-tb"
        this.$changeOptionsEV("horizontal-tb", curWritingMode, false)
      } else {
        this[curActiveArrangementOrder].isActive = true
        // this[curWritingMode] = "vertical-lr"
        this.$changeOptionsEV("vertical-lr", curWritingMode, false)
      }
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },

    initProvinceData() {
      const _provinceData = []
      this.pcaCode.forEach(province => {
        _provinceData.push({ value: province.code, label: province.name })
        this.provinceData = _provinceData
      })
    },
    initCitysData(name) {
      if (!name || name === "" || name === "全国") return
      const _cityData = []
      let citys = this.pcaCode.find(province => province.name === name.split("/")[0])
      if (citys && citys.children.length === 1) {
        //直辖市没有更下一级 所以直接获取下一级
        citys = citys.children[0]
      }
      citys.children.forEach(city => {
        _cityData.push({ value: city.code, label: city.name })
      })
      this.cityData = _cityData
    },
    changeProvince(provinceCode) {
      if (!provinceCode) {
        this.$changeOptionsEV("全国", "selectName", false)
      } else {
        const name = this.provinceData.find(item => item.value === provinceCode).label
        const jsonLocation = `${name}/${name}.${provinceCode + new Array(6 - provinceCode.length).fill(0).join("")}`
        this.$changeOptionsEV(jsonLocation, "selectName", false)
      }
    },
    changeCity(cityCode) {
      let porvince = this.pcaCode.find(province => province.name === this.province)
      let specialProvince
      if (porvince.children.length === 1) {
        //处理直辖市
        specialProvince = 1
        porvince = porvince.children[0]
      }
      const city = porvince.children.find(city => city.code === cityCode)
      const jsonLocation = `${this.province}/${specialProvince ? "" : city.name + "/"}${city.name}.${
      city.code + new Array(6 - city.code.length).fill(0).join("")
          }`
      this.$changeOptionsEV(jsonLocation, "selectName", false)
    },
  }
}
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}
.w172 {
  width: 172px;
}
::v-deep.custom-weather-color .el-color-picker,
::v-deep.custom-weather-color .el-color-picker__trigger {
  width: 100%;
}
</style>
